// @flow
import React from 'react';
import Authenticator from './protocol/Authenticator';
import InfiniteProgress from './common/InfiniteProgress';
import ViewUtil from './ViewUtil';
import CollectionUtil from './queries/lightbox/CollectionUtil';
import LinkSharingProperties from './queries/lightbox/LinkSharingProperties';
import ErrorId from './protocol/ErrorId';
import AuthenticationController from './controllers/AuthenticationController';
import BottomLeftTip from './common/BottomLeftTip';
import LsZmCollectionAssets from './queries/lightbox/assets/LsZmCollectionAssets';
import { CollectionParametersObject } from './autogenerated/ZoomBridge';
import GlobalSpinner from './GlobalSpinner';
import t from './i18n/I18n';
import Authenticator2 from './auth/Authenticator2';
import Storage from './protocol/Storage';
import randomstring from 'randomstring';
import { ThemeSetup } from './themes/ThemeSetup';
import System from './basic/System';
import Lazyload from './lazyload/LazyLoad';
import { togglePageLoadPlaceholder } from './util/DOMUtil';
import LoggedBlock from './LoggedBlock';
import { NULL_OAUTH_REALM } from './auth/AuthMechanism';
import LoginScreenHandler from './login/LoginScreenHandler';
import ErrorModal from './modals/error/ErrorModal';
import CredentialsModal from './modals/userinput/CredentialsModal';
import { SUBTAB } from './util/Constants';
// const LoggedBlock = Lazyload(() => import('./LoggedBlock'));
// const NotLoggedBlock = Lazyload(() => import('./login/NotLoggedBlock'));
//const ErrorModal = Lazyload(() => import('./modals/error/ErrorModal'));
const InfoModal = Lazyload(() => import('./modals/info/InfoModal'));
const StoreWindow = Lazyload(() => import('./store/StoreWindow'));
// const OAuthNotLoggedInBlock = Lazyload(() => import('./login/OAuthNotLoggedInBlock'));

const debug = require('./debug/debug')('wc:Root');
const electron = System.isDesktop() ? window.require('electron') : null;
const ipcRenderer = System.isDesktop() ? electron.ipcRenderer : null;
if (ipcRenderer) {
  window.onerror = function (error = '', url = '', line = '') {
    console.log(error, url, line);
    ipcRenderer.send('errorInWindow', { error, url, line });
  };
}

type State = {
  loading: boolean,
  isDarkTheme: boolean,
  currentTheme: Theme,
  onAdditionalCredentials: Function
};

export default class Root extends React.Component<{}, State> {
  constructor(props: {}) {
    super(props);
    this.state = {
      loading: ViewUtil.isDirectLinkToCollection(),
      isDarkTheme: true,
      error: null,
      onAdditionalCredentials: null
    };
    if (!!Storage.get('zm_web_session') === false) {
      Storage.set('zm_web_session', randomstring.generate({ length: 12, readable: false, capitalization: false }));
    }
  }

  componentWillMount() {
    window.setError = this.setError;
    this.setState({ onAdditionalCredentials: null });
  }

  // setTheme = () => {
  //   const theme = this.state.isDarkTheme ? Theme.DARK : Theme.LIGHT; //this.state.themes[this.state.currentTheme];
  //   const themeSettings = theme.currentThemeSettings();
  //   Object.keys(themeSettings).forEach((key) => {
  //     document.body.style.setProperty(key, themeSettings[key]);
  //   });
  // };

  componentDidMount() {
    if (System.isDesktop()) {
      togglePageLoadPlaceholder(true, true).then(() => setTimeout(() => ipcRenderer.send('openApp'), 300));
    }

    const isDirectLinkToCollection: boolean = ViewUtil.isDirectLinkToCollection();
    debug('[componentDidMount()] isDirectLinkToCollection: ', isDirectLinkToCollection);

    if (isDirectLinkToCollection) {
      /**
       * It is direct link to a collection.
       * We need to now directly goto collection without displaying assets and collection tab.
       * User would directly be inside the collection.
       */
      this.setState({ loading: true, onAdditionalCredentials: null });
      const collectionId = ViewUtil.getCollectionIdFromArgs();
      const promise = this.issueLsCollectionAssetsToCheckIfCurrentLoggedInUserHasPermission(collectionId);
      promise
        .then(() => this.setState({ loading: false }))
        .catch((error) => {
          debug('[componentDidMount()] error in LsZmCollectionAssets: ', error);
          const collectionId = ViewUtil.getCollectionIdFromArgs();
          const privateLinkId = ViewUtil.getPrivateLinkId();
          CollectionUtil.getCollectionParameters(collectionId, this.onCollectionAuthParameters, privateLinkId);
          //Now if confirmed that entered url in browser is direct link to collection.
          //We can't proceed with normal sign-in or display until further collection details are received.
          //Those collection details would be received in onCollectionParameters method below in this class.
          //Wrote by om on 1st Oct 2017
        });
    } else {
      this.setState({ onAdditionalCredentials: null });
    }
    this.setDefaultTheme();
  }

  setDefaultTheme = () => {
    ThemeSetup.updateTheme();
  };

  setError = (error: any = null) => {
    this.setState({ error: error });
  };

  /**
   *
   * @param {number} collectionId
   */
  issueLsCollectionAssetsToCheckIfCurrentLoggedInUserHasPermission = (collectionId: number) => {
    const query = new LsZmCollectionAssets(collectionId);
    query.doNoUserAuthenticator();
    return query.run(false);
  };

  onCollectionAuthParameters = (params: CollectionParametersObject, errorId: ErrorId) => {
    if (!this.onCollectionParameters(params, errorId))
      return;

    const loadCollection = (() => {
      CollectionUtil.getCollectionParameters(params.getCollectionId(), this.onCollectionParameters)
        .then(() => this.setState({ loading: false, onAdditionalCredentials: null }))
        .catch(this.finishLoadingCollection);
    }).bind(this);
    const loginAndLoad = ((password: ?string = null) => {
      this.loginWithCollectionLink(ViewUtil.getPrivateLinkId(), password)
        .then(() => {
          if (window.gs.isLogged) {
            window.errorMessageForLinkUser = null;
            this.setError(null);
            loadCollection();
          } else {
            this.finishLoadingCollection();
          }
        })
        .catch(this.finishLoadingCollection);
    }).bind(this);
    if (CollectionUtil.isLinkSharingPasswordProtected(params.getCollectionParams())) {
      // TODO: Add the code for login if a password-protected private link
      /* Example:
          LoginScreenHandler.obtainPasswordFromUser()
            .then(loginAndLoad)
            .catch(this.finishLoadingCollection);
      */
      this.setState({ loading: false, onAdditionalCredentials: loginAndLoad });
    } else {
      loginAndLoad();
    }
  }
  /**
   * This methos is called when private link to collection is detect in URL.
   * So, from this method we can decide what kind of UI we have to display now.
   * Till that time show loadin..
   * @param {CollectionParametersObject} params
   * @param {ErrorId} errorId
   */
  onCollectionParameters = (params: CollectionParametersObject, errorId: ErrorId) => {
    debug('[onCollectionParameters()] args: ', { params, errorId });

    if (errorId) {
      window.setError(errorId.toString());
      this.finishLoadingCollection();
      return false;
    }
    if (params == null || params.getCollectionId() == null || params.getCollectionId() <= 0) {
      window.setError(t('INVALID_SHARING_SETTINGS'));
      this.finishLoadingCollection();
      return false;
    }

    const privateLinkId = ViewUtil.getPrivateLinkId();
    /**
     * @type {LinkSharingProperties}
     */
    const linkSharingProperties = new LinkSharingProperties(params, privateLinkId);
    window.gs.linkSharingData = linkSharingProperties;
    window.setARGS({ activeTab: 'COLLECTIONS', activeSubTab: SUBTAB.ALL.KEY });

    /**
     * With the new permissions model, the only thing we check here is if
     * the Link Sharing Enabled checkbox was checked. If not,
     * the next block shows the error. Otherwise the user
     * gets logged in and all is good in the world. Kyle, 2018-01-24.
     */

    if (linkSharingProperties.isLinkSharingDisabled()) {
      window.setError(t('LINK_SHARING_DISABLED'));
      this.finishLoadingCollection();
      return false;
    }
    return true;

    // } else if (linkSharingProperties.isLoginRequired() || linkSharingProperties.isLinkSharingInviteOnly()) {
    //   //Login is required.
    //   //Ask user to first login then nonly user can see the collection.
    //   if (this.logger.isDebug()) {
    //     this.logger.debug("Login is required to view the contents of this link");
    //   }

    //   // Probably nothing to do here since the login screen is going to appear anyway.
    //   this.setState({ loading: false });
    // } else if (linkSharingProperties.isReadOnlyLink() || linkSharingProperties.canCommentWithLink()) {
    //   //At this point, user can proceed and view the collection.
    //   //But commenting can be disabled if canCommentWithLink is false. but it can be checked later on.
    //   if (this.logger.isDebug()) {
    //     this.logger.debug("User can proceed and view the contents of the collection.");
    //   }
    //   //If we are in this if block then no need to ask for user name and password. Let us to implicit auth.
    //   //If we set username and password same as the unique code present in url. Server must give us access to collection.
    //   this.displayCollectionContentsWithoutLogin(linkSharingProperties);
    // } else {
    //   // Does this block ever execute?
    //   this.setState({ loading: false });
    // }
  };

  /**
   *
   * @param {string} uniqueId
   * @param {string?} password; optional
   * @return {Promise}
   */
  loginWithCollectionLink(linkId: string, password: ?string = null): Promise {
    let authRealm = Authenticator2.getAuthRealmForExternalUserFromWindowsArgument();
    if (!authRealm) {
      authRealm = Authenticator2.isBasicMechanismAvailable()
        ? Authenticator2.findBasicAuthType()[0].getAuthRealm()
        : null;
    }
    if (!authRealm) {
      authRealm = NULL_OAUTH_REALM;
    }
    Authenticator.AUTHENTICATOR_INSTANCE.authRealm = authRealm;
    return AuthenticationController.signin(linkId, password == null ? linkId : password);
  }

  finishLoadingCollection = ((e: ?Error = null) => {
    if (e != null) console.log(e);
    this.setState({ loading: false });
  }).bind(this);

  render() {
    const { error } = this.state;
    if (this.state.loading) {
      return (
        <div className="flex-row align-center justify-center full-height">
          <img src={ThemeSetup.getImageURL('RingSpinner.svg')} />
        </div>
      );
    }
    const additionalCredentialsHandler = this.state.onAdditionalCredentials;
    if (additionalCredentialsHandler != null) {
      return CredentialsModal.getCredentialsModal({
        onCancel: () => {
          this.setState({ loading: false, onAdditionalCredentials: null });
        },
        onSubmit: (password) => {
          this.setState({ loading: true });
          additionalCredentialsHandler(password);
        },
        errorMsg : this.state.error ? this.state.error : null
      });
    }
    return (
      <div style={{ minHeight: '100%' }}>
        {window.gs.bottomLeftTip ? (
          <BottomLeftTip
            message={window.gs.bottomLeftTip.message}
            dismissDelay={window.gs.bottomLeftTip.dismissDelay}
          />
        ) : null}
        <InfiniteProgress />
        {window.gs.isLogged ? <LoggedBlock /> : this.renderNotLoggedInBlock()}
        {error ? <ErrorModal>{error}</ErrorModal> : null}
        {window.gs.infoMsg ? <InfoModal>{window.gs.infoMsg}</InfoModal> : null}
        {process.env.NODE_ENV === 'development' ? <StoreWindow /> : null}
        {/* <GlobalSpinner /> */}
      </div>
    );
  }

  renderNotLoggedInBlock() {
    return <LoginScreenHandler />;
  }
}
